import React from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';

const { VITE_HELP_CENTRE_URL } = getEnv();

export const faqsConfig = [
  {
    question: 'What makes Pata the right booking software for dog trainers?',
    answer: () => (
      <>
        <p>
          Pata is designed specifically for dog trainers and other pet care professionals. Built with easy-to-use
          features, our platform helps you grow your client base, simplify admin, and minimise no-shows.  
        </p>

        <p>
          Whether you offer solo training sessions in your client’s home or manage multiple locations for group classes,
          you get full access to an intuitive booking platform that streamlines your business and makes bookings easy —
          all without monthly fees.
        </p>
      </>
    ),
  },
  {
    question: 'Can clients book dog training sessions online?',
    answer: () => (
      <>
        <p>
          Our booking platform puts you in control of your time, allowing you to take bookings online or simply use the
          calendar as a digital diary.
        </p>

        <p>
          If you choose to enable online bookings, customers get 24/7 access to scheduling appointments which means
          fewer calls for you and a seamless experience for them. This feature can be limited to existing clients only,
          or opened up to new customers as well.
        </p>

        <p>No matter how you prefer to take bookings, Pata has flexible features to suit your business needs.</p>
      </>
    ),
  },
  {
    question: 'Can I collect payments or deposits in advance?',
    answer: () => (
      <>
        <p>
          Yes, you can. As a proven way to reduce no-shows and late cancellations, Pata makes it easy to take{' '}
          <Link to="/business/pata-pay">upfront payments</Link> and minimise frustration for your pet care business.
        </p>

        <p>
          When clients book online, you can collect their payment card for any no-show or late cancellation charges. You
          also have the option to set a custom deposit amount or choose to request full payments in advance, giving you
          control of your income and protecting your time.
        </p>
      </>
    ),
  },

  {
    question: 'How can Pata help me grow my dog training business?',
    answer: () => (
      <>
        <p>
          As a partner, you get access to the Pata Marketplace which is a one-stop-shop for pet owners looking to book
          trusted professionals in their area.
        </p>

        <p>
          When they search on Pata or Google for local pet training services, our Marketplace increases your online
          presence, helping pet parents discover your business and expanding your network of loyal customers.
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata suitable for part-time or solo dog trainers?',
    answer: () => (
      <>
        <p>
          Pata is designed for pet training businesses of every size and can support your journey from the very
          beginning.
        </p>

        <p>
          Whether you’re starting out part-time and working solo or growing your business with additional team members,
          Pata helps you find local pet owners and take bookings online, making appointment management easy and reducing
          no-shows.
        </p>

        <p>
          You’ll get access to the same <Link to="/business/features">powerful tools </Link>
          no matter your size, including online payments with card on file functionality, a Pata Marketplace profile,
          automated reminders and a digital calendar for online bookings.
        </p>

        <p>
          Best of all, our software is subscription-free and flexible, so you can grow at your own pace without monthly
          fees.
        </p>
      </>
    ),
  },
  {
    question: 'Is Pata really subscription-free?',
    answer: () => (
      <>
        <p>
          Absolutely, it is! We believe every pet training business should have easy access to digital tools that
          simplify tedious admin tasks, so our booking software is subscription-free.
        </p>

        <p>
          At Pata, we offer unlimited appointment bookings, client and email notifications, locations, and team members
          without any upfront or monthly fees to limit your growth.
        </p>

        <p>
          Other features like SMS top-ups and online or in-person payments are also available if you want to take that
          extra step, but they are completely optional.
        </p>
      </>
    ),
  },
  {
    question: 'Can I manage dog training, and other pet care services with Pata?',
    answer: () => (
      <>
        <p>
          Pata booking platform is designed for all pet care professionals, built with flexible features that make it
          easy to manage both training sessions and additional services from one business account.
        </p>

        <p>
          Whether you split your time between training and walking, or run a busy school by day and offer dog boarding
          by night, it’s easy to add multiple workplaces with individual operating hours, team members and Pata
          Marketplace profiles.
        </p>

        <p>
          You can also switch between workplaces on our simple dashboard and intuitive calendar, helping you schedule
          your time across multiple businesses and view important information in a few clicks.
        </p>
      </>
    ),
  },
];
